import React, { useState, useEffect, useRef } from "react";
import { addDays, addMonths, subYears } from "date-fns";
import { useVisaRules } from "./useVisaRules.js";

const toNoon = (d) => {
  if (!d) return null;

  const dt = new Date(d);

  if (isNaN(dt)) return null;

  return new Date(
    dt.getFullYear(),
    dt.getMonth(),
    dt.getDate(),
    12,
    0,
    0,
    0
  );
};

const useQuoteFormState = ( initialVisaType = "Super Visa", initialInsured = "single" ) => {

  const changingFromEndRef = useRef(false);
  const manualDaysChangedRef = useRef(false);
  const isFromUrlRef = useRef(false);

  const [visaType, setVisaType] = useState(initialVisaType);
  const [insured, setInsured] = useState(initialInsured);
  const { getCoverageOptions } = useVisaRules();
  const [coverageOptions, setCoverageOptions] = useState([]);
  const [coverage, setCoverage] = useState(100000);

  const today = toNoon(new Date());
  const maxStartDate = toNoon(addDays(today, 365 * 2));
  const defaultStartDate = addMonths(today, 1);
  const [startDate, setStartDate] = useState(defaultStartDate);
  const [noOfDays, setNoOfDays] = useState(365);
  const [endDate, setEndDate] = useState(toNoon(addDays(defaultStartDate, 364)));
  const [minEndDate, setMinEndDate] = useState(toNoon(addDays(today, 365)));
  const [maxEndDate, setMaxEndDate] = useState(toNoon(addDays(today, 365 * 3)));
  const defaultAge = 60;
  const defaultDOB = toNoon(subYears(defaultStartDate, defaultAge));
  const [dob1, setDob1] = useState(defaultDOB);
  const [age1, setAge1] = useState(defaultAge);
  const [medical1, setMedical1] = useState("No");
  const [dob2, setDob2] = useState(defaultDOB);
  const [age2, setAge2] = useState(defaultAge);
  const [medical2, setMedical2] = useState("No");
  const [minDob, setDob] = useState(toNoon(subYears(today, 99)));

  useEffect(() => {
    const options = getCoverageOptions(visaType);
    setCoverageOptions(options);
    setCoverage(coverage);
    if (visaType === "Super Visa") {
      setMinEndDate(toNoon(addDays(today, 365)));
      setMaxEndDate(toNoon(addDays(today, 365 * 3 )));
    } else {
      setMinEndDate(toNoon(addDays(today, 7)));
      setMaxEndDate(toNoon(addDays(today, 365 * 3 )));
    }
  }, [visaType]);

  useEffect(() => {
    if (changingFromEndRef.current) {
      changingFromEndRef.current = false;
      return;
    }

    if (visaType === "Super Visa") {
      setNoOfDays(365);
      setEndDate(toNoon(addDays(startDate, 364)));
    } else {
      if (manualDaysChangedRef.current) {
        setEndDate(toNoon(addDays(startDate, noOfDays - 1)));
      } else {
        const min = 60;
        const max = 365;
        const clamped = Math.max(min, Math.min(noOfDays, max));
        setNoOfDays(clamped);
        setEndDate(toNoon(addDays(startDate, clamped - 1)));
      }
    }
  }, [startDate]);

  useEffect(() => {
    if (changingFromEndRef.current) {
      changingFromEndRef.current = false;
      return;
    }

    if (visaType === "Super Visa") {
      manualDaysChangedRef.current = false; // reset
      setNoOfDays(365);
      setEndDate(toNoon(addDays(startDate, 364)));
    } else {
      if (isFromUrlRef.current) return;
      /*
      const min = 7;
      const max = 365;

      const clamped = Math.max(min, Math.min(noOfDays, max));
      setNoOfDays(clamped);
      setEndDate(toNoon(addDays(startDate, clamped - 1)));

      manualDaysChangedRef.current = false; // reset manual override
      */

      const defaultVisitorDays = 60;

      setNoOfDays(defaultVisitorDays);
      setEndDate(toNoon(addDays(startDate, defaultVisitorDays - 1)));
    }
  }, [visaType]);


  return {
    visaType,
    manualDaysChangedRef,
    setVisaType,
    insured,
    setInsured,
    coverageOptions,
    coverage,
    setCoverage,
    today,
    startDate,
    setStartDate,
    maxStartDate,
    endDate,
    setEndDate,
    minEndDate,
    maxEndDate,
    noOfDays,
    setNoOfDays,
    dob1,
    setDob1,
    age1,
    setAge1,
    medical1,
    setMedical1,
    dob2,
    setDob2,
    age2,
    setAge2,
    medical2,
    setMedical2,
    minDob,
    changingFromEndRef,
    isFromUrlRef,
  };
};

export default useQuoteFormState;
